import { render } from "./LinkTile.vue?vue&type=template&id=e96d9bd4&scoped=true"
import script from "./LinkTile.vue?vue&type=script&lang=js"
export * from "./LinkTile.vue?vue&type=script&lang=js"

import "./LinkTile.vue?vue&type=style&index=0&id=e96d9bd4&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96d9bd4"]])

export default __exports__